import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const paymentMethodAPI = axios.create({
  baseURL: `${API_BASE_URL}/payment-method`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const paymentMethodService = {
  getByContext: async (context) => {
    const response = await paymentMethodAPI.get(`/by-context/${context}`);
    return response.data;
  },
};

export default paymentMethodService;
